import { DATE_FORMAT } from '@leagueplatform/web-common';

export const UTC_DATE_FORMAT = { ...DATE_FORMAT, timeZone: 'UTC' };

export const APP_ID = 'scan-web';
export const TENANT_ID = 'scan';
export const APP_NAME = 'SCAN';
export const APP_NAME_LONG = 'SCAN Health';
export const APP_NAME_LONG_ALT = 'SCAN Health Plan';

export const ROUTE_PATHS = {
  VERIFY_EMAIL: '/verify-email',
  HOME: '/home',
  SIGN_IN: '/sign-in',
  SIGN_OUT: '/sign-out',
  ACCOUNT_INFO: '/settings/account-information',
  COMMUNICATION_PREFERENCES: '/communication-preferences',
  ABOUT: '/about',
  DOCUMENT_PREFERENCES: () =>
    `${ROUTE_PATHS.COMMUNICATION_PREFERENCES}/document-preferences`,
  CHANGE_DOCTOR: '/change-doctor',
  MEMBER_REDIRECT: '/member',
  PRIOR_AUTHORIZATIONS: '/get-care/prior-authorizations',
  PRIOR_AUTHORIZATIONS_DETAILS: '/prior-authorizations/:authorizationId',
  PRESCRIPTIONS: '/prescriptions',
  PRESCRIPTION_DETAILS: '/prescriptions/:prescriptionId',
  REFILL_SCORE: '/refill-score',
  REFILL_SCORE_DETAILS: '/refill-score/:category',
  CONTACT_SCAN: '/contact-scan',
  EXERCISE_YOUR_BRAIN: '/exercise-your-brain',
  GENERIC_MASONRY_PAGE: '/masonry/:version/:id',
  BENEFITS: '/benefits',
  HEALTH_ASSESSMENT:
    '/health-journey/campaign/4hjfHxSH6kVJbFbJcqoHOG/activity/EQkTzwL393rgcz2MXvkZl/toolbox',
  HEALTHY_REWARDS_FAQ: '/healthy-rewards-faq',
};

export const LOCAL_STORAGE_KEYS = {
  FEATURE_HIGHLIGHTS_COMPLETED: 'feature_highlights_completed',
};

export const SENTRY_CONSTANTS = {
  OWNERSHIP_TEAM: 'scan-web',
};

export const COMMUNICATION_METHOD_CODES = {
  ONLINE: 'email',
  MAIL: 'mail',
  NONE: 'none',
};

export const POST_LOGOUT_URL = 'https://www.scanhealthplan.com';

export const EXTERNAL_URLS = {
  TERMS_OF_USE: 'https://www.scanhealthplan.com/legal',
  PRIVACY_POLICY:
    'https://www.scanhealthplan.com/Legal/Privacy/Web-Mobile-Privacy-Policy',
  NOTICE_OF_PRIVACY_PRACTICES:
    'https://www.scanhealthplan.com/Legal/Privacy/Notice-of-Privacy-Practices',
  PHI_AUTHORIZATION:
    'https://scan-q-002.sitecorecontenthub.cloud/api/public/content/form-authorization-for-the-use-and-disclosure-of-phi?v=5e55b71c',
  NON_DISCRIMINATION_POLICY:
    'https://www.scanhealthplan.com/Legal/Nondiscrimination-and-Accessiblity-Requirements',
  DISCLAIMER: 'https://www.scanhealthplan.com/Legal',
  SCAN_SCHEDULE_CALL:
    'https://www.scanhealthplan.com/Help-Center/Contact-Us/schedule-a-call',
  SCAN_EXERCISE_YOUR_BRAIN_CTA:
    'https://www.scanhealthplan.com/supplemental-benefits-2025/fitness-membership',
  AUTO_PAY_REQUEST:
    'https://www.scanhealthplan.com/help-center/contact-us/SCAN-forms/request-a-scan-form',
  DISENROLLMENT_FORM:
    'https://scan-q-002.sitecorecontenthub.cloud/api/public/content/c747d1e02a2148f6ab397e6eb6615286?v=36a1864d',
  PHI_REQUEST_FORM:
    'https://scan-q-002.sitecorecontenthub.cloud/api/public/content/ffc5c8fdb2ac420ab16ff5d7118cd0dc?v=bee6c530',
  GRIEVANCES_AND_APPEALS:
    'https://www.scanhealthplan.com/Help-Center/Contact-Us/File-A-Grievance',
  FIVE_WISHES:
    'https://www.scanhealthplan.com/Health-and-Wellness/Navigating-Your-Health-Journey/Advanced-Care-Planning',
  CONSENT_VERBALLY_SHARE_PHI:
    'https://scan-q-002.sitecorecontenthub.cloud/api/public/content/ec7596318fc34789aa61309445403741?v=7ab7628e',
  APPS_FOR_SCAN_BENEFITS:
    'https://www.scanhealthplan.com/plans-and-benefits/app-store',
  MOBILE_APPS: {
    // IOS
    APP_STORE: 'https://apps.apple.com/us/app/scan-health-plan/id6742335951',
    // ANDROID
    GOOGLE_PLAY_STORE:
      'https://play.google.com/store/apps/details?id=com.scanhealthplan.scan',
  },
};
